var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React from 'react';
import styled from '@emotion/styled';
import cookieStorage from '../../common/CookieStorage';
import { withLocale } from '../../common/providers/LocaleProvider';
import { NavigationGroup, NavigationItem, NavigationLink, } from './NavigationList';
var BottomNavigationLink = styled(NavigationLink)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  justify-content: flex-start;\n"], ["\n  justify-content: flex-start;\n"])));
var BottomNavigationSection = /** @class */ (function (_super) {
    __extends(BottomNavigationSection, _super);
    function BottomNavigationSection(props) {
        var _this = _super.call(this, props) || this;
        _this.state = { customer: null };
        return _this;
    }
    BottomNavigationSection.prototype.componentDidMount = function () {
        this.setState({
            customer: cookieStorage.getCustomer(),
        });
    };
    BottomNavigationSection.prototype.render = function () {
        var l10n = this.props.l10n;
        var _a = this.state.customer || {}, _b = _a.firstName, firstName = _b === void 0 ? '' : _b, _c = _a.isLoggedIn, isLoggedIn = _c === void 0 ? false : _c;
        var navigation = [
            isLoggedIn
                ? {
                    label: l10n.replace(l10n.t('h24_not_your_account'), {
                        username: firstName,
                    }),
                    href: l10n.prefix.t('h24_logout_url'),
                }
                : {
                    label: l10n.t('h24_register'),
                    href: l10n.prefix.t('h24_register_url'),
                },
            {
                label: l10n.t('h24_my_account'),
                href: l10n.prefix.t('h24_my_overview_url'),
            },
            {
                label: l10n.t('h24_help_contact'),
                href: l10n.prefix.t('h24_help_contact_url'),
            },
        ];
        return (React.createElement(NavigationGroup, null, navigation.map(function (item, index) { return (React.createElement(NavigationItem, { key: index, as: "li" },
            React.createElement(BottomNavigationLink, { href: item.href, dangerouslySetInnerHTML: { __html: item.label } }))); })));
    };
    return BottomNavigationSection;
}(React.PureComponent));
export default withLocale(BottomNavigationSection);
var templateObject_1;
